export default "/images/footer-two-bg.png?0c4949c49ef38468ca26cf09aca4ed65";